import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginDirectlyComponent } from './login-directly/login-directly.component';
import { NoCompanyComponent } from './no-company/no-company.component';

@NgModule({
  declarations: [ LoginComponent, LogoutComponent, LoginDirectlyComponent, NoCompanyComponent ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    MatNativeDateModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule
  ],
  providers: [ CookieService ],
  exports: [
      LoginComponent, LogoutComponent, LoginDirectlyComponent, NoCompanyComponent
  ]
})
export class SecurityModule { }
